import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import PrepaidProvider from '@components/prepaid/PrepaidProvider';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ChargeAgreements from './components/ChargeAgreements';
import ChargeAmount from './components/ChargeAmount';
import ChargeCardSummary from './components/ChargeCardSummary';
import ChargePaymentInfo from './components/ChargePaymentInfo';
import PrepaidCardChargeFooter from './components/PrepaidCardChargeFooter';

interface Params {
    prepaidCardId: string;
    amount?: number;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardChargeActivity: Params;
    }
}

const PrepaidCardChargeActivity: ActivityComponentType<'PrepaidCardChargeActivity'> = ({ params }) => {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCardId, amount } = params;
    const [agreed, setAgreed] = useState(false);

    return (
        <AppScreen>
            <PrepaidProvider>
                <CtaLayout header={<Header title={t('charge.title')} />}
                    footer={<PrepaidCardChargeFooter id={prepaidCardId} agreed={agreed} />}>
                    <Column fullWidth>
                        <ChargeCardSummary cardId={prepaidCardId} />
                        <Divider />
                        <ChargeAmount cardId={prepaidCardId} initialAmount={amount} />
                        <Divider/>
                        <ChargePaymentInfo cardId={prepaidCardId} />
                        <Divider/>
                        <ChargeAgreements agreed={agreed} onAgreedChange={setAgreed} />
                    </Column>
                </CtaLayout>
            </PrepaidProvider>
        </AppScreen>
    );
};

export default PrepaidCardChargeActivity;
